"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _theme = _interopRequireDefault(require("./theme.proptypes"));
var Themes = _interopRequireWildcard(require("./themes"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
// import React, { Suspense } from 'react';

const Theme = props => {
  const {
    children,
    theme
  } = props;
  // eslint-disable-next-line import/namespace
  const ThemeToUse = theme in Themes ? Themes[theme] : Themes.AIRASIA_CLASSIC;
  return /*#__PURE__*/(
    // <Suspense fallback={<div>Loading...</div>}>
    _react.default.createElement(ThemeToUse, null, children)
    // </Suspense>
  );
};
Theme.propTypes = _theme.default.PropTypes;
var _default = exports.default = Theme;